import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';

import * as styles from './list-render.module.scss';

const Ul = ({
  children,
  nested = false,
  withDashes = false,
  withArrows = false,
  lime = false,
  blue = false,
  className,
}) => {
  return (
    <ul
      className={cx(styles.ul, className, {
        [styles.nested]: nested,
        [styles.withDash]: withDashes,
        [styles.arrow]: withArrows,
        [styles.lime]: lime,
        [styles.blue]: blue,
      })}
    >
      {children}
    </ul>
  );
};

Ul.propTypes = {
  children: PropTypes.node,
  nested: PropTypes.bool,
  withDashes: PropTypes.bool,
  withArrows: PropTypes.bool,
  lime: PropTypes.bool,
  blue: PropTypes.bool,
  className: PropTypes.string,
};

const Li = ({
  children,
  className,
  dash = false,
  arrow = false,
  lime = false,
  blue = false,
  nested = false,
  forceNoIcon = false,
}) => {
  return (
    <li
      className={cx(className, {
        [styles.nested]: nested,
        [styles.withDash]: dash,
        [styles.arrow]: arrow,
        [styles.lime]: lime,
        [styles.blue]: blue,
        [styles.noIcon]: forceNoIcon,
      })}
    >
      {children}
    </li>
  );
};

Li.propTypes = {
  className: PropTypes.string,
  dash: PropTypes.bool,
  arrow: PropTypes.bool,
  lime: PropTypes.bool,
  blue: PropTypes.bool,
  nested: PropTypes.bool,
  forceNoIcon: PropTypes.bool,
};

export const ListRender = ({
  className,
  data = [],
  nested = false,
  withDashes = false,
  withArrows = false,
  lime = false,
  blue = false,
}) => {
  const inheritableProps = { nested, withDashes, withArrows, lime, blue };
  return (
    <Ul {...inheritableProps} className={className}>
      {data.map((value, index) => {
        const isArray = Array.isArray(value);
        return (
          <Li key={index} forceNoIcon={isArray}>
            {isArray ? <ListRender data={value} {...inheritableProps} /> : value}
          </Li>
        );
      })}
    </Ul>
  );
};

ListRender.propTypes = {
  data: PropTypes.node,
  nested: PropTypes.bool,
  withDashes: PropTypes.bool,
  withArrows: PropTypes.bool,
  lime: PropTypes.bool,
  blue: PropTypes.bool,
  className: PropTypes.string,
};

ListRender.Ul = Ul;
ListRender.Li = Li;
